"use client";

import { CheckoutProvider } from "@stripe/react-stripe-js/checkout";
import { STRIPE_FONT_SRC } from "@/lib/constants";
import { loadStripe } from "@stripe/stripe-js";
import { useMemo } from "react";

interface CheckoutWrapperProps {
  clientSecret: string;
  stripeAccountId: string;
  children: React.ReactNode;
}

export function CheckoutWrapper({
  clientSecret,
  stripeAccountId,
  children,
}: CheckoutWrapperProps) {
  // Avoid recreating on every render
  const stripePromise = useMemo(
    () =>
      loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!, {
        stripeAccount: stripeAccountId,
      }),
    [stripeAccountId],
  );

  return (
    <CheckoutProvider
      stripe={stripePromise}
      options={{
        clientSecret,
        elementsOptions: {
          fonts: STRIPE_FONT_SRC,
          appearance: {
            theme: "stripe",
            variables: {
              colorPrimary: "#4f39f6",
              fontFamily: "Mona Sans",
            },
          },
        },
      }}
    >
      {children}
    </CheckoutProvider>
  );
}
